import { Tab } from "@headlessui/react";
import React, { Fragment, useContext, useEffect, useState } from "react";
import styled, { ThemeContext } from "styled-components";
import ConfigContext from "../contexts/AppContext";
import AppContext from "../contexts/AppContext";
import LeftBarContext from "../contexts/LeftBarContext";
import { createBrowserHistory } from "history";
import classNames from "classnames";
import icons from "../icons";
import appFetch from "../appFetch";
import { appendQueryToUri } from "../util/generalUtil";
import apiEndpoints from "../apiEndpoints";

const Icon = styled.div`
  width: 33px;
  height: 33px;
  background: ${({ theme, read }) => theme?.colors.accent};
  color: ${({ theme, read }) => theme?.colors.primary};
  /* border: 1px solid #ffdede; */
  box-sizing: border-box;
  border-radius: 5px;
`;

const NotificationItem = styled.li`
  background: ${({ theme, read }) => (read ? theme?.colors.accent : "inherit")};
  border-bottom: 1px solid #f3f3f3;
  padding-bottom: 10px;
`;

const TabHead = styled.div`
  box-shadow: 0px 1px 2px rgb(0 0 0 / 15%);
`;

const Badge = styled.span`
  width: 18px;
  height: 18px;
  font-size: 0.7em;
  color: ${({ theme, active }) =>
    active ? theme?.colors?.primary : "#BBBBBB"};
  background: ${({ theme, active }) =>
    active ? theme?.colors.accent : "#F3F3F3"};
`;

const MenuText = styled.div`
  color: ${({ theme, active }) => (active ? theme.colors?.primary : "#838383")};
  font-weight: ${({ active }) => (active ? "600" : "normal")};
`;

const iconMap = {
  home: "HomeIcon",
  setup: "SetupIcon",
  transaction: "TransactionIcon",
  approval: "ApprovalIcon",
  memo: "MemoIcon",
  open: "OpenIcon",
  dashboard: "DashboardIcon",
  confirmation: "ConfirmationIcon",
  payrollReports: "PayrollReportsIcon",
  otherReports: "OtherReportsIcon",
  essReports: "EssReportsIcon",
  bioData: "BioDataIcon",
  Online: "OnlineIcon",
  Users: "UsersIcon",
  Retail: "RetailIcon",
  Wallet: "WalletIcon",
  Ussd: "UssdIcon",
  Draws: "DrawsIcon",
  ThirdParty: "ThirdPartyIcon",
  Accuracy: "AccuracyIcon",
  Feeds: "FeedsIcon",
  Whatsapp: "WhatsappIcon",
  Error: "ErrorIcon",
  Calender: "CalenderIcon",
  map: "MapIcon",
  Statistics: "StatisticsIcon",
  OtherReports: "OtherReportsIcon",
  Ticket: "TicketIcon",
  Search: "SearchIcon",
  report: "OtherReportsIcon",
  Forms: "FormsIcon",
  module: "FormsIcon",
  reports: "StatisticsIcon",
  money: "MoneyIcon",
  action: "ActionIcon",
  followup: "FollowUpIcon",
  pending: "PendingIcon",
  qualified: "PassIcon",
  schedule: "ScheduledIcon",
  demo: "DemoIcon",
  proposal: "PlanIcon",
  onboarding: "OnboardIcon",
  crm: "CRMIcon",
  sales: "SalesIcon",
  inventory: "InventoryIcon",
  horizontalbarchart: "HorizontalBarIcon",
  verticalbarchart: "VerticalBarIcon",
  scatterchart: "ScatterIcon",
  layout: "LayoutIcon",
  piechart: "PieIcon",
  linechart: "LineIcon",
  "": "setup",
};

function BannerModal({ options, setLoading }) {
  const [activeItem, setActiveItem] = useState();

  const { config, setConfig } = useContext(ConfigContext);
  const theme = useContext(ThemeContext);
  const { context, setContext } = useContext(AppContext);
  const { menuCollapse, setMobileMenuOpen } = useContext(LeftBarContext);
  // const history = useHistory();
  const history = createBrowserHistory();
  const {
    location: { pathname },
  } = history;

  let _pathname = pathname.split("/").slice(-1)[0]?.toLowerCase() || "home";
  _pathname = decodeURI(_pathname.replace(/\//, "")).replace(/\-/g, " ");
  let patt = RegExp(_pathname, "i");
  console.log("patt", patt);
  let activeMenu = options?.find((menu) => patt.test(menu?.name));
  let { targetid: menuId } = activeMenu || {};

  const currentPath = pathname.split("/").slice(-1)[0]?.toLowerCase() || "home";

  useEffect(() => {
    setContext((prev) => ({ ...prev, menuId }));
  }, [pathname]);

  console.log("contextData", context);

  console.log("initial options", options);
  let groupedOrder = {};
  let optionsGroup = [];
  let optionsGroupLen = -1;

  options.forEach((o) => {
    if (o.group) {
      const groupKey = o.group.trim(); // normalization, optionally use toLowerCase()

      if (!(groupKey in groupedOrder)) {
        groupedOrder[groupKey] = ++optionsGroupLen;
      }

      const index = groupedOrder[groupKey];

      if (!optionsGroup[index]) {
        optionsGroup[index] = {
          name: groupKey,
          icon: o.groupicon,
          options: [o],
        };
      } else {
        optionsGroup[index].options.push(o);
      }
    } else {
      optionsGroup[++optionsGroupLen] = o;
    }
  });

  const loadPage = (item) => {
    setLoading(true);

    let postData = {
      urlMenu: null,
      layoutId: null,
      targetId: item.targetid,
      target: "MENU",
      schemaId: null,
      txnGroup: null,
      parentDropValue: null,
    };

    console.log("what is this load page postData", postData);
    appFetch
      .get(appendQueryToUri(apiEndpoints.menuView, postData))
      .then((res) => {
        let link = `${item.name.toLowerCase()}`;
        history.push(link.replace(/\s/g, "-"));
        // setContextMenuId(menuId)
        console.log("the response for loadpage", res);
        let page = { ...context.pageConfig };
        let [leftArea, MainArea, rightArea] = page.subcomponents;
        page.subcomponents = [leftArea, res, rightArea];

        setContext((prev) => ({
          ...prev,
          menuId: item.targetid,
          pageConfig: page,
        }));
      })
      .catch((e) => console.log(e.message))
      .finally(() => setLoading(false));
  };

  const openNewPage = (item) => {
    // setMobileMenuOpen(true);
    console.log(
      "the open new page function",
      item.name.toLowerCase(),
      activeMenu?.name.toLowerCase()
    );
    if (item.name.toLowerCase() === activeMenu?.name.toLowerCase()) return;
    loadPage(item);
  };

  const dataOptions = optionsGroup.map((o) => o.options);

  console.log("banner optionsGroup", optionsGroup, dataOptions);

  return (
    <div className="p-3 pt-3 relative">
      <Tab.Group>
        <Tab.List as={TabHead} className="flex pt-2 px-3 -mx-3 gap-5 mb-4">
          {optionsGroup &&
            optionsGroup.map(({ name, icon, options }, idx) => {
              let index = idx + 1;
              const menuIcon = iconMap[icon] || "setup";
              const testMenuIcon = iconMap["onboarding"];
              const patt = new RegExp(`^${name}$`, "i");
              const active = patt.test(activeMenu?.name);

              return (
                <Tab as="button" key={index}>
                  {({ selected }) => (
                    <span
                      className={classNames(
                        "text-sm font-medium capitalize py-3 mx-auto leading-normal flex items-center place-items-center justify-center gap-2 ", // Added flex styles
                        {
                          "text-black border-b-2 border-color-primary":
                            selected,
                          "text-gray-400": !selected,
                        }
                      )}
                    >
                      {/* Optional: wrap name and icon in a fragment or div to ensure layout */}
                      <span>{name}</span>
                      {icons[menuIcon] &&
                        React.createElement(icons[menuIcon], {
                          width: 20,
                          height: null,
                          fill: selected ? theme?.colors?.primary : "#AAAAAA",
                          stroke: selected ? theme?.colors?.primary : "#AAAAAA",
                        })}
                    </span>
                  )}
                </Tab>
              );
            })}
        </Tab.List>
        <Tab.Panels className="grid gap-3">
          {dataOptions.map((item, idx1) => (
            <Tab.Panel>
              <ul className="grid gap-3" key={idx1}>
                {item?.map((option, idx) => {
                  let { name, icon, badge } = option;
                  let menuIcon = iconMap[icon];
                  const patt = new RegExp(`^${name}$`, "i");
                  const active = patt.test(activeMenu?.name);

                  return (
                    <li
                      key={idx}
                      className="mb-2 ml-2 flex items-center cursor-pointer"
                      onClick={() => {
                        console.log("does this onclick work");
                        openNewPage(option);
                      }}
                    >
                      {icons[menuIcon] &&
                        React.createElement(icons[menuIcon], {
                          width: 20,
                          height: null,
                          fill: active ? theme?.colors?.primary : "#AAAAAA",
                          stroke: active ? theme?.colors?.primary : "#AAAAAA",
                        })}
                      <MenuText
                        className="flex capitalize pl-3 leading-1 text-gray-custom tracking-wide flex items-center"
                        active={active}
                      >
                        <span>{name}</span>
                        {typeof badge != "undefined" && (
                          <Badge className="font-semibold ml-2 rounded-sm inline-grid place-items-center rounded-xl">
                            {badge}
                          </Badge>
                        )}
                      </MenuText>
                    </li>
                  );
                })}
              </ul>
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}

export default BannerModal;
